import {ICreateSuggestion, IRespondSuggestion} from '@app-types/websocket/suggestion.types';

import {createAction} from 'redux-act';

export const createSuggestion = createAction<ICreateSuggestion>('Create suggestion');
export const respondSuggestion = createAction<IRespondSuggestion>('Respond to suggestion');
export const selectSuggestionId = createAction<number>('Select suggestionId');
export const loadSuggestionHistory = createAction<number>('Load suggestion history');



// WEBPACK FOOTER //
// ./src/services/suggestion/suggestion.action.ts